export default "__VITE_ASSET__87058425__"